<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — HEADER
     تجمع من أجل أمة
     ════════════════════════════════════════════════ -->

<!-- Mobile overlay -->
<div class="vfu-overlay" [class.active]="classApplied" (click)="toggleClass()"></div>

<header class="vfu-header" [class.scrolled]="isSticky" role="banner">
  <div class="vfu-header-inner">

    <!-- Logo -->
    <a class="vfu-logo" routerLink="/" aria-label="الصفحة الرئيسية">
      <img [src]="createImgPath(logoHeader)" alt="شعار المنظمة">
    </a>

    <!-- Desktop Navigation -->
    <nav class="vfu-nav d-none d-md-flex" role="navigation" aria-label="القائمة الرئيسية">
      <a routerLink="/"
         class="vfu-nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        {{"MENU.Home" | translate}}
      </a>
      <a routerLink="/about"
         class="vfu-nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        {{"MENU.About" | translate}}
      </a>
      <a routerLink="/news"
         class="vfu-nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        {{"MENU.News" | translate}}
      </a>
      <!-- Categories dropdown -->
      <div class="vfu-nav-dropdown" [class.open]="isCatOpen"
           (mouseenter)="isCatOpen=true" (mouseleave)="isCatOpen=false">
        <button class="vfu-nav-link vfu-nav-dropdown-trigger" type="button">
          {{"MENU.PublicNews" | translate}}
          <svg class="vfu-nav-chevron" [class.rotated]="isCatOpen"
               width="12" height="12" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>
        <div class="vfu-nav-dropdown-menu">
          <a class="vfu-nav-dropdown-item"
             routerLink="/public-news"
             (click)="isCatOpen=false">
            <i class='bx bx-list-ul'></i>
            الكل
          </a>
          <a *ngFor="let cat of categoryNews"
             class="vfu-nav-dropdown-item"
             [routerLink]="['/public-news']"
             [queryParams]="{category: cat.referenceId}"
             (click)="isCatOpen=false">
            <i class='bx bx-bookmark'></i>
            {{ cat.name }}
          </a>
        </div>
      </div>
      <a routerLink="/activity"
         class="vfu-nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        {{"MENU.Activity" | translate}}
      </a>
      <a routerLink="/contact"
         class="vfu-nav-link"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        {{"MENU.Contact" | translate}}
      </a>
    </nav>

    <!-- Right-side actions -->
    <div class="vfu-header-actions">

      <!-- Language selector -->
      <app-language-selector></app-language-selector>

      <!-- Social icons (desktop) -->
      <div class="vfu-social d-none d-lg-flex" aria-label="التواصل الاجتماعي">
        <a class="vfu-social-link" (click)="openSocalMediaNewWindow(faceBook)" title="فيسبوك" tabindex="0">
          <i class='bx bxl-facebook'></i>
        </a>
        <a class="vfu-social-link" (click)="openSocalMediaNewWindow(twitter)" title="تويتر" tabindex="0">
          <i class='bx bxl-twitter'></i>
        </a>
        <a class="vfu-social-link" (click)="openSocalMediaNewWindow(instagram)" title="إنستغرام" tabindex="0">
          <i class='bx bxl-instagram'></i>
        </a>
        <a class="vfu-social-link" (click)="openSocalMediaNewWindow(youtube)" title="يوتيوب" tabindex="0">
          <i class='bx bxl-youtube'></i>
        </a>
      </div>

      <!-- Hamburger (mobile) -->
      <button class="vfu-hamburger d-md-none"
              [class.open]="classApplied"
              type="button"
              (click)="toggleClass()"
              aria-label="فتح القائمة">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button>
    </div>

  </div>
</header>

<!-- Mobile Navigation Drawer -->
<nav class="vfu-mobile-nav" [class.open]="classApplied" aria-label="القائمة على الجوال">
  <div class="mobile-nav-header">
    <a routerLink="/" (click)="toggleClass()">
      <img [src]="createImgPath(logoHeader)" alt="الشعار" style="height:48px;">
    </a>
    <button class="mobile-nav-close" (click)="toggleClass()" aria-label="إغلاق">
      <i class='bx bx-x'></i>
    </button>
  </div>

  <a routerLink="/" class="mobile-nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="toggleClass()">
    {{"MENU.Home" | translate}}
  </a>
  <a routerLink="/about" class="mobile-nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="toggleClass()">
    {{"MENU.About" | translate}}
  </a>
  <a routerLink="/news" class="mobile-nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="toggleClass()">
    {{"MENU.News" | translate}}
  </a>
  <!-- Mobile categories accordion -->
  <div class="mobile-nav-accordion">
    <button class="mobile-nav-link mobile-accordion-trigger"
            (click)="isMobileCatOpen=!isMobileCatOpen" type="button">
      {{"MENU.PublicNews" | translate}}
      <svg [class.rotated]="isMobileCatOpen" width="14" height="14"
           viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </button>
    <div class="mobile-accordion-body" [class.open]="isMobileCatOpen">
      <a class="mobile-nav-sub-link" routerLink="/public-news"
         (click)="toggleClass(); isMobileCatOpen=false">
        الكل
      </a>
      <a *ngFor="let cat of categoryNews"
         class="mobile-nav-sub-link"
         [routerLink]="['/public-news']"
         [queryParams]="{category: cat.referenceId}"
         (click)="toggleClass(); isMobileCatOpen=false">
        {{ cat.name }}
      </a>
    </div>
  </div>
  <a routerLink="/activity" class="mobile-nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="toggleClass()">
    {{"MENU.Activity" | translate}}
  </a>
  <a routerLink="/contact" class="mobile-nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="toggleClass()">
    {{"MENU.Contact" | translate}}
  </a>

  <div class="mobile-social">
    <a (click)="openSocalMediaNewWindow(faceBook)" tabindex="0"><i class='bx bxl-facebook'></i></a>
    <a (click)="openSocalMediaNewWindow(twitter)" tabindex="0"><i class='bx bxl-twitter'></i></a>
    <a (click)="openSocalMediaNewWindow(instagram)" tabindex="0"><i class='bx bxl-instagram'></i></a>
    <a (click)="openSocalMediaNewWindow(youtube)" tabindex="0"><i class='bx bxl-youtube'></i></a>
  </div>
</nav>
